module.exports = __webpack_public_path__ + "media/images/iconPaginatePrev--dark-423edb99837ecc72b8348c40f7120262.png";